import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDetailQuota, setState } from "./quotaCopySlice";
import CircleIcon from '@mui/icons-material/Circle';
import TableCellCheckbox from "./TableCellCheckbox";
import TableColCheckbox from "./TableColCheckbox";
import moment from "moment";

function quotaDetailsTableCol() {
	const columns = [
      { 
         field: "checkbox", 
         headerName: "checkbox" ,
         disableColumnMenu: true,
         hideSortIcons: true,
         filterable: false,
         width: 60,
         renderCell: TableCellCheckbox,
         renderHeader: (params) => {
            return <TableColCheckbox />;
         },
      },
		{ field: "scenarioName", headerName: "Scenario", width: 200 },
		{ field: "countryName", headerName: "Country", width: 100 },
      {  
         field: "criticalityId", 
         headerName: "Criticality", 
         width: 100,
         renderCell: Criticality
      },
		{ field: "quotaStatus", headerName: "Quota Status", width: 100 },
		{
			field: "previousTotalForecast",
			headerName: "Previous Total Quota",
			width: 200,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         }
		},
		{ field: "initialForecast", headerName: "Initial Quota", width: 100,      
         valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString();
         return formattedValue;
         } },
		{ field: "totalForecast", headerName: "Total Quota", width: 100,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         } },
      // { field: "sit", headerName: "SIT", width: 100 },
      { field: "unusedQuota", headerName: "Unused Quota - Previous Period", width: 100,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         } },
      { 
         field: "lastActionDate", 
         headerName: "Last Action Date", 
         width: 200,
         valueGetter: (params) => {
            let date = params.row.lastActionDate;
            date = date.split("T");
            return date[0];
         } ,
         valueFormatter: (params) => {
            if(params.value === "") return params.value;
            else {
               return moment(params.value).format('DD/MM/YYYY')
            }
         }
      },
		{ field: "lastActionBy", headerName: "Last Action By", width: 200 },
		{ field: "period", headerName: "Period", width: 100 },
	];
	return columns;
}

export default function Table() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quotaCopy);
	const { quotaDetails, quotaDetailsTable, selectedTableRow } = state;
	const { rows } = quotaDetailsTable;
   const columns = quotaDetailsTableCol();

	function setRowSelected(selRow) {
      console.log(selRow);
		dispatch(setState("selectedTableRow", selRow));
		getDetailedQuota(selRow);
	}

	function getDetailedQuota(selRows) {
      dispatch(setState("detailQuotaTable", null));
      if(selRows.length > 0) {
         const quota = quotaDetails[selRows[selRows.length - 1]];

         const obj = {
            quotaID: quota.quotaID,
            countryID: quota.geoID,
            scenarioID: quota.scenarioID,
            validityStartDate: quota.effectiveStartDate,
            validityEndDate: quota.effectiveEndDate,
         };
         console.log("Define_Quota Copy Submit_getDetailedQuota", obj);
         dispatch(getDetailQuota(obj));
      }
	}

	return (
		<Box sx={{ mt: 3 }}>
			<DataGrid
				rows={rows}
				columns={columns}
				onRowSelectionModelChange={(selectedRow) => {
					setRowSelected(selectedRow);
				}}
            disableColumnMenu
				rowSelectionModel={selectedTableRow}
			/>
		</Box>
	);
}

function Criticality(params) {

   const colors = [
      { id: 5, color: "blue.main" },
      { id: 4, color: "black.main" },
      { id: 3, color: "red.main" },
      { id: 2, color: "orange.main" },
      { id: 1, color: "green.main" },
   ];

   const color = colors.find(c => c.id === params.row.criticalityId).color;
   return (
      <Box>
         <CircleIcon sx={{ color: color }}/>
      </Box>
   );
}
